import { gql } from '@apollo/client';

export const pendingReturnProductsQuery = gql`
  query ($personId: ID!, $initialRow: Int, $nextRows: Int) {
    pendingReturnProducts(personId: $personId, initialRow: $initialRow, nextRows: $nextRows){
      personId
      personName
      productId
      productName
      volume
      itemQuantity
      totalRows
    }
  }
`;
